import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RootRedirect: React.FC = () => {
  const { isAuthenticated } = useAuth();
  
  // If user is authenticated, redirect to skills page
  if (isAuthenticated) {
    return <Navigate to="/marketplace/skills" replace />;
  }
  
  // If user is not authenticated, redirect to marketplace
  return <Navigate to="/marketplace" replace />;
};

export default RootRedirect;